/**
 * Constants used in the Collaborative Whiteboard integration.
 * This object contains string constants for API endpoints, metadata keys, and other relevant identifiers.
 */
export const CollaborativeWhiteboardConstants = Object.freeze({
    v1_create: "v1/create",
    extension_whiteboard: "extension_whiteboard",
    whiteboard: "whiteboard",
    extensions: "extensions",
    metadata: "metadata",
    injected: "@injected",
    post: "POST"
})